import { SwiperProps } from "@made-people/blueprint-swiper";
import { ChevronLeft } from "../../../assets/icons/ChevronLeft";
import { ChevronRight } from "../../../assets/icons/ChevronRight";

export const Swiper: SwiperProps = {
  settings: {
    template: "template1",
    spacing: {
      x: {
        initial: "md",
        md: "lg",
        lg: "xl",
      },
      y: {
        initial: "2xl",
        md: "3xl",
        lg: "3xl",
      },
      gap: {
        initial: "xs",
        md: "sm",
        lg: "md",
      },
      maxWidth: "page",
    },
    headerSettings: {
      heading: {
        variants: {
          eyebrowSize: { initial: "sm", lg: "md" },
          headingSize: {
            initial: "lg",
            md: "xl",
            lg: "2xl",
          },
        },
      },
    },
    variants: {
      background: "none",
      layout: "stacked",
    },
    navigation: {
      prevIcon: <ChevronLeft />,
      nextIcon: <ChevronRight />,
    },
    pagination: {
      mobile: {
        enabled: false,
      },
      desktop: {
        enabled: false,
      },
    },
  },
};
